import { useState } from 'react';
import { categories, trustBadges, mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelectedCategory(url);
      window.open(url, '_blank');
      e.target.value = '';
    }
  };

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Thoughtfully%20curated%20flatlay%20of%20stylish%20fashion%20items%20including%20linen%20shirt%20folded%20denim%20and%20leather%20watch%20arranged%20with%20dried%20botanicals%20on%20textured%20off%20white%20paper%20background%20overhead%20shot%20diffused%20natural%20window%20light%20casting%20soft%20organic%20shadows%20editorial%20lifestyle%20photography%20warm%20neutral%20palette%20artistic%20composition&width=1600&height=900&seq=hero-bg-2026-v3&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/40 to-background-50/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-24 pb-12 md:pt-28 md:pb-20">
        <div className="max-w-4xl">
          <span className="inline-block px-3 py-1 rounded-full border border-foreground-300/40 bg-background-50/30 backdrop-blur-sm text-foreground-700 text-xs md:text-sm font-medium mb-6">
            2026 Updated
          </span>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-semibold text-foreground-950 leading-tight tracking-tight mb-4">
            Superbuy Spreadsheet
          </h1>
          <p className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-700 font-medium italic mb-5">
            Discover Products Faster
          </p>

          <p className="text-sm md:text-base text-foreground-600 max-w-lg mb-8 leading-relaxed">
            The complete Superbuy Spreadsheet resource for finding trending products, organized
            categories, verified information and smarter shopping guides — all in one place.
          </p>

          <div className="flex flex-wrap gap-2 md:gap-3 mb-10">
            {trustBadges.map((badge) => (
              <div
                key={badge.text}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/60 backdrop-blur-sm border border-background-200/50"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${badge.icon} text-accent-500 text-xs`}></i>
                </div>
                <span className="text-xs text-foreground-600 whitespace-nowrap">{badge.text}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <div className="relative w-full sm:w-64">
              <select
                value={selectedCategory}
                onChange={handleCategoryChange}
                className="w-full appearance-none bg-background-50 border border-background-200 rounded-xl px-4 py-3 text-sm text-foreground-700 cursor-pointer focus:outline-none focus:border-primary-300 transition-colors font-body"
              >
                <option value="" disabled>
                  Browse Categories...
                </option>
                {categories.map((cat) => (
                  <option key={cat.slug} value={cat.url}>
                    {cat.name}
                  </option>
                ))}
              </select>
              <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-down-s-line text-foreground-400 text-sm"></i>
              </div>
            </div>

            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-5 py-3 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:border-foreground-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
            >
              Superbuy Sheet
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </div>
            </a>

            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-5 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Buy It Now
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}